import { render, staticRenderFns } from "./BranchManager.vue?vue&type=template&id=49b0d752"
import script from "./BranchManager.vue?vue&type=script&lang=js"
export * from "./BranchManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports